import React from 'react';
import InstructorCourses from '../components/instructorCourse/index';
function InstructorCoursesPage() {
    return <InstructorCourses />;
}

export default InstructorCoursesPage;
